import services from "./index";

export const doCreateUser = (data) => {
  return services.users.create(data);
};
